import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Sidebar } from './components/Sidebar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Products } from './pages/Products';
import { Contact } from './pages/Contact';
import { QuickCont } from './pages/products/QuickCont';
import { Facelec } from './pages/products/Facelec';
import { GalenosWeb } from './pages/products/GalenosWeb';
import { ScrollToTop } from './components/ScrollToTop';
const AppContent = () => {
  const location = useLocation();
  const getBackgroundColor = () => {
    switch (location.pathname) {
      case '/quickcont':
        return 'bg-gradient-to-br from-teal-600 to-teal-700';
      case '/facelec':
        return 'bg-gradient-to-br from-orange-600 to-orange-700';
      case '/galenos':
        return 'bg-gradient-to-br from-red-600 to-red-700';
      default:
        return 'bg-gradient-to-br from-blue-600 to-blue-700';
    }
  };
  const isProductRoute = ['/quickcont', '/facelec', '/galenos'].includes(location.pathname);
  return <div className="relative min-h-screen">
      <ScrollToTop />
      <div className={`fixed inset-0 transition-colors duration-300 ${getBackgroundColor()}`} />
      <div className="relative z-10 flex min-h-screen">
        <div className="flex-1">
          {!isProductRoute && <Navbar />}
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quickcont" element={<QuickCont />} />
              <Route path="/facelec" element={<Facelec />} />
              <Route path="/galenos" element={<GalenosWeb />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Sidebar />
      </div>
    </div>;
};
export function App() {
  return <Router>
      <AppContent />
    </Router>;
}